<template>
    <div
        class="EvaluationRuleModalRequirementCard"
        :class="{
            'EvaluationRuleModalRequirementCard--selected': isSelected,
            'EvaluationRuleModalRequirementCard--disabled': isDisabled
        }"
        @click="toggleSelection"
    >
        <div class="EvaluationRuleModalRequirementCard__checkbox">
            <Checkbox
                v-model="selectedValue"
                :disabled="isDisabled"
            />
        </div>
        <EidIcon
            class="mr-3"
            :icon-src="iconSrc"
            :svg-props="{ width: 28 }"
        />
        <div class="EvaluationRuleModalRequirementCard__content">
            <div class="EvaluationRuleModalRequirementCard__label">
                {{ option.label }}
            </div>
            <div class="EvaluationRuleModalRequirementCard__criteriaCount">
                {{ criteriaCount }} criteria
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import Checkbox from '@evidentid/dashboard-commons/components/Checkbox/Checkbox.vue';
    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';
    import { TprmRequirementType } from '@evidentid/tprm-portal-lib/models/entity-details';

    import { getRequirementTypeIconUri } from '@/modules/entity-details/utils/getRequirementTypeIconUri';

    export interface RequirementOption {
        id: string;
        value: TprmRequirementType;
        label: string;
    }

    export default defineComponent({
        name: 'EvaluationRuleModalRequirementCard',
        components: {
            EidIcon,
            Checkbox,
        },
        props: {
            option: {
                type: Object as PropType<RequirementOption>,
                required: true,
            },
            criteriaCount: {
                type: Number,
                required: true,
            },
            isSelected: {
                type: Boolean,
                default: false,
            },
            isDisabled: {
                type: Boolean,
                default: false,
            },
        },
        emits: [ 'change' ],
        computed: {
            iconSrc(): string {
                return getRequirementTypeIconUri(this.option.value);
            },
            selectedValue: {
                get(): boolean {
                    return this.isSelected;
                },
                set(): void {
                    this.toggleSelection();
                },
            },
        },
        methods: {
            toggleSelection(): void {
                if (this.isDisabled) {
                    return;
                }
                this.$emit('change', {
                    requirement: this.option.value,
                    selected: !this.isSelected,
                });
            },
        },
    });
</script>
